import { useRef } from "react";
import HomeNav from "@/components/HomeNav";
import HomeFooter from "@/components/HomeFooter";
import useEditorialMotion from "@/hooks/useEditorialMotion";
import "@/homepage.css";

export function SitePage({ children }) {
  const siteRef = useRef(null);
  useEditorialMotion(siteRef);

  return (
    <div className="av-site av-subpage" ref={siteRef}>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <HomeNav />
      <main id="main-content">{children}</main>
      <HomeFooter />
    </div>
  );
}

export function PageHero({ label, title, intro, aside, children }) {
  return (
    <section className="av-page-hero" aria-labelledby="av-page-title">
      <div className="av-shell av-page-hero-grid">
        <div>
          <p className="av-kicker">{label}</p>
          <h1 id="av-page-title">{title}</h1>
          {intro && <p className="av-page-intro">{intro}</p>}
          {children}
        </div>
        {aside && <aside className="av-page-aside">{aside}</aside>}
      </div>
    </section>
  );
}
